import { create } from 'zustand';
// import { shallow } from 'zustand/shallow'; // Not used due to Zustand v5 selector API

interface PinnedRowsState {
    pinnedRowIds: string[];
    setPinnedIds: (ids: string[]) => void;
    pinRow: (id: string) => void;
    unpinRow: (id: string) => void;
}

const useInternalPinnedRowsStore = create<PinnedRowsState>((set) => ({
    pinnedRowIds: [],
    setPinnedIds: (ids) => set({ pinnedRowIds: ids }),
    pinRow: (id) => set((state) => ({ pinnedRowIds: [...state.pinnedRowIds, id] })),
    unpinRow: (id) => set((state) => ({ pinnedRowIds: state.pinnedRowIds.filter((rowId) => rowId !== id) })),
}));

// Selectors
export const usePinnedIds = () => useInternalPinnedRowsStore((state) => state.pinnedRowIds);
export const useSetPinnedIds = () => useInternalPinnedRowsStore((state) => state.setPinnedIds);
export const usePinRow = () => useInternalPinnedRowsStore((state) => state.pinRow);
export const useUnpinRow = () => useInternalPinnedRowsStore((state) => state.unpinRow); 